import React, { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import BlueButton from "../../../../Component/Common/BlueButton";
import { BASE_URL } from "../../../../config/api";

export default function UpdateRetailerForm({ retailer, onClose, onSuccess }) {
  const [loadingPin, setLoadingPin] = useState(false);
  console.log("retailer from prop: ", retailer)

  // allowed editable fields
  const editableFields = [
    "business_name",
    "owner_full",
    "official_email",
    "phone_no",
    "address1",
    "location",
    "state"
  ];

  

  // Prefilled form
 const [form, setForm] = useState({
  first_name: retailer.owner_first_name || "",
  middle_name: retailer.owner_middle_name || "",
  last_name: retailer.owner_last_name || "",

  phone_no: retailer.contact_phone || "",
  official_email: retailer.contact_email || "",
  position: retailer.position || "",

  address1: retailer.address_line1 || "",
  address2: retailer.address_line2 || "",
  pincode: retailer.pincode || "",
  state: retailer.state || "",
  district: retailer.district || "",
  taluka: retailer.taluka || "",
  location: retailer.city || "",

  business_name: retailer.business_name || "",

  owner_contact: retailer.owner_contact || "",
  owner_email: retailer.owner_email || "",
  pan_no: retailer.pan_no || "",

  owner_full: `${retailer.owner_first_name  || ""} ${retailer.owner_last_name  || ""}`.trim(),
});



  const [errors, setErrors] = useState({});

  // Handle changes only for editable fields
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (!editableFields.includes(name)) return; // lock non-editable fields

    setForm((prev) => ({ ...prev, [name]: value }));

    if (name === "pincode" && value.length === 6) {
      fetchPinDetails(value);
    }

    validateField(name, value);
  };

  // Auto-fill address from pincode
  const fetchPinDetails = async (pincode) => {
    try {
      setLoadingPin(true);

      const res = await axios.get(
        `https://goelectronix.in/public/api/v1/pincode/${pincode}`
      );

      if (res.data?.success) {
        setForm((prev) => ({
          ...prev,
          state: res.data.state,
          district: res.data.district,
          taluka: res.data.taluk || "",
        }));

        setErrors((prev) => ({ ...prev, pincode: "" }));
      } else {
        setErrors((prev) => ({ ...prev, pincode: "Invalid pincode" }));
        Swal.fire("Invalid Pincode", "Enter a correct pincode.", "error");
      }
    } catch {
      Swal.fire("Error", "Unable to fetch pincode details.", "error");
    } finally {
      setLoadingPin(false);
    }
  };

  // Field validation
  const validateField = (name, value) => {
    let error = "";

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^[6-9]\d{9}$/;
    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;

    switch (name) {
      case "business_name":
      case "owner_full":
      case "address1":
      case "location":
      case "state":
        if (!value.trim()) error = "This field is required";
        break;

      case "phone_no":
        if (!value.trim()) error = "This field is required";
        else if (!phoneRegex.test(value)) error = "Invalid 10-digit number";
        break;

      case "official_email":
        if (!value.trim()) error = "This field is required";
        else if (!emailRegex.test(value)) error = "Invalid email";
        break;

      default:
        break;
    }

    setErrors((prev) => ({ ...prev, [name]: error }));
    return error === "";
  };

  // Validate only editable fields
  const validateForm = () => {
    let valid = true;
    editableFields.forEach((key) => {
      if (!validateField(key, form[key])) valid = false;
    });
    return valid;
  };

  // SUBMIT update API
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      Swal.fire("Error", "Please fix validation errors.", "error");
      return;
    }

    const payload = {
      retailer_name: form.business_name,
      owner_name: form.owner_full,
      email: form.official_email,
      phone: form.phone_no,
      address_line1: form.address1,
      city: form.location,
      state: form.state,
      contact_email: retailer.contact_email,
      pincode: retailer.pincode,
      role: retailer.role,
    };

    try {
      const res = await axios.post(
        `${BASE_URL}common/update`,
        payload
      );

      if (res.data.status) {
        Swal.fire("Success", "Retailer updated successfully!", "success");
        onSuccess();
      } else {
        Swal.fire("Error", res.data.message || "Update failed", "error");
      }
    } catch (err) {
      Swal.fire("Error", "Failed to update retailer.", "error");
    }
  };

  // Reusable Input UI — now auto-locks fields
  const renderInput = (label, name, type = "text") => {
    const isEditable = editableFields.includes(name);

    return (
      <div>
        <label className="block text-sm font-medium text-slate-700">{label}</label>
        <input
          type={type}
          name={name}
          value={form[name]}
          onChange={isEditable ? handleChange : undefined}
          readOnly={!isEditable}
          maxLength={name === "pincode" ? 6 : undefined}
          className={`mt-1 border rounded-lg px-3 py-2 text-sm w-full ${
            !isEditable ? "bg-gray-100 cursor-not-allowed" : ""
          }`}
        />
        {errors[name] && isEditable && (
          <p className="text-xs text-red-500 mt-1">{errors[name]}</p>
        )}
      </div>
    );
  };

  return (
    <div className="mx-auto bg-white shadow-md rounded-2xl p-4 mt-2">
      <form onSubmit={handleSubmit} className="space-y-8">

        {/* Personal */}
        <div>
          <h3 className="text-lg font-semibold text-slate-800 mb-2">
            Authorised Person Information
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {renderInput("First Name", "first_name")}
            {renderInput("Middle Name", "middle_name")}
            {renderInput("Last Name", "last_name")}
            {/* {renderInput("Owner Contact Number", "owner_contact")} */}
            {/* {renderInput("Owner Email ID", "owner_email", "email")} */}
            {/* {renderInput("Position", "position")} */}
          </div>
        </div>

        {/* Address */}
        <div>
          <h3 className="text-lg font-semibold text-slate-800 mb-2">
            Address Details
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {renderInput("Address Line 1", "address1")}
            {renderInput("Address Line 2", "address2")}
            {renderInput("Pincode", "pincode")}
            {renderInput("State", "state")}
            {renderInput("District", "district")}
            {/* {renderInput("Taluka", "taluka")} */}
            {renderInput("City", "location")}
          </div>
        </div>

        {/* Business */}
        <div>
          <h3 className="text-lg font-semibold text-slate-800 mb-2">
            Business Information
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {renderInput("Business Name", "business_name")}

            {/* Editable combined owner field */}
            {/* {renderInput("Owner Full Name", "owner_full")} */}
            {renderInput("Phone Number", "phone_no")}
            {renderInput("Official Email ID", "official_email", "email")}
            {/* {renderInput("PAN Number", "pan_no")} */}
          </div>
        </div>

        {/* Buttons */}
        <div className="flex justify-end gap-3">
          <BlueButton type="button" onClick={onClose}>
            Cancel
          </BlueButton>
          <BlueButton type="submit">Save Changes</BlueButton>
        </div>
      </form>
    </div>
  );
}



// import React, { useState } from "react";
// import axios from "axios";
// import Swal from "sweetalert2";
// import BlueButton from "../../../../Component/Common/BlueButton";

// export default function UpdateRetailerForm({ retailer, onClose, onSuccess }) {
//   const [loadingPin, setLoadingPin] = useState(false);

//   // Prefilled form
//   const [form, setForm] = useState({
//     first_name: retailer.first_name || "",
//     middle_name: retailer.middle_name || "",
//     last_name: retailer.last_name || "",
//     phone_no: retailer.phone_no || "",
//     official_email: retailer.official_email || "",
//     position: retailer.position || "",
//     address1: retailer.address1 || "",
//     address2: retailer.address2 || "",
//     pincode: retailer.pincode || "",
//     state: retailer.state || "",
//     district: retailer.district || "",
//     taluka: retailer.taluka || "",
//     location: retailer.location || "",
//     business_name: retailer.business_name || "",
//     owner_first: retailer.owner_first || "",
//     owner_middle: retailer.owner_middle || "",
//     owner_last: retailer.owner_last || "",
//     owner_contact: retailer.owner_contact || "",
//     owner_email: retailer.owner_email || "",
//     pan_no: retailer.pan_no || "",
//   });

//   const [errors, setErrors] = useState({});

//   // Handle changes
//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     setForm((prev) => ({ ...prev, [name]: value }));

//     // Auto-fetch pincode
//     if (name === "pincode" && value.length === 6) {
//       fetchPinDetails(value);
//     }

//     validateField(name, value);
//   };

//   // Auto-fill address from pincode
//   const fetchPinDetails = async (pincode) => {
//     try {
//       setLoadingPin(true);

//       const res = await axios.get(
//         `https://goelectronix.in/public/api/v1/pincode/${pincode}`
//       );

//       if (res.data?.success) {
//         setForm((prev) => ({
//           ...prev,
//           state: res.data.state,
//           district: res.data.district,
//           taluka: res.data.taluk || "",
//         }));

//         setErrors((prev) => ({ ...prev, pincode: "" }));
//       } else {
//         setErrors((prev) => ({ ...prev, pincode: "Invalid pincode" }));
//         Swal.fire("Invalid Pincode", "Enter a correct pincode.", "error");
//       }
//     } catch {
//       Swal.fire("Error", "Unable to fetch pincode details.", "error");
//     } finally {
//       setLoadingPin(false);
//     }
//   };

//   // Field validation
//   const validateField = (name, value) => {
//     let error = "";

//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     const phoneRegex = /^[6-9]\d{9}$/;
//     const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;

//     switch (name) {
//       case "first_name":
//       case "last_name":
//       case "position":
//       case "address1":
//       case "business_name":
//       case "owner_first":
//       case "owner_last":
//         if (!value.trim()) error = "This field is required";
//         break;

//       case "phone_no":
//       case "owner_contact":
//         if (!value.trim()) error = "This field is required";
//         else if (!phoneRegex.test(value)) error = "Invalid 10-digit number";
//         break;

//       case "official_email":
//       case "owner_email":
//         if (!value.trim()) error = "This field is required";
//         else if (!emailRegex.test(value)) error = "Invalid email address";
//         break;

//       case "pincode":
//         if (!value.trim()) error = "This field is required";
//         else if (value.length !== 6) error = "Pincode must be 6 digits";
//         break;

//       case "pan_no":
//         if (!value.trim()) error = "This field is required";
//         else if (!panRegex.test(value)) error = "Invalid PAN format (ABCDE1234F)";
//         break;

//       default:
//         break;
//     }

//     setErrors((prev) => ({ ...prev, [name]: error }));
//     return error === "";
//   };

//   // Validate entire form
//   const validateForm = () => {
//     let valid = true;
//     Object.keys(form).forEach((key) => {
//       if (!validateField(key, form[key])) valid = false;
//     });
//     return valid;
//   };

//   // SUBMIT update API
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!validateForm()) {
//       Swal.fire("Error", "Please fix validation errors.", "error");
//       return;
//     }

//     try {
//       const res = await axios.post(
//         `${BASE_URL}/retailer/update/${retailer.id}`,
//         form
//       );

//       if (res.data.status) {
//         Swal.fire("Success", "Retailer updated successfully!", "success");
//         onSuccess();
//       } else {
//         Swal.fire("Error", res.data.message || "Update failed", "error");
//       }
//     } catch (err) {
//       Swal.fire("Error", "Failed to update retailer.", "error");
//     }
//   };

//   // Reusable Input UI
//   const renderInput = (label, name, type = "text", readOnly = false) => (
//     <div>
//       <label className="block text-sm font-medium text-slate-700">{label}</label>
//       <input
//         type={type}
//         name={name}
//         value={form[name]}
//         onChange={handleChange}
//         readOnly={readOnly}
//         maxLength={name === "pincode" ? 6 : undefined}
//         className={`mt-1 border rounded-lg px-3 py-2 text-sm w-full ${
//           readOnly ? "bg-gray-100" : ""
//         }`}
//       />
//       {errors[name] && <p className="text-xs text-red-500 mt-1">{errors[name]}</p>}
//       {loadingPin && name === "pincode" && (
//         <p className="text-xs text-blue-600 mt-1">Fetching...</p>
//       )}
//     </div>
//   );

//   return (
//     <div className="mx-auto bg-white shadow-md rounded-2xl p-4 mt-2">
//       <form onSubmit={handleSubmit} className="space-y-8">

//         {/* Personal */}
//         <div>
//           <h3 className="text-lg font-semibold text-slate-800 mb-2">
//             Authorised Person Information
//           </h3>

//           <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//             {renderInput("First Name", "first_name")}
//             {renderInput("Middle Name", "middle_name")}
//             {renderInput("Last Name", "last_name")}
//             {renderInput("Phone Number", "phone_no")}
//             {renderInput("Official Email ID", "official_email", "email")}
//             {renderInput("Position", "position")}
//           </div>
//         </div>

//         {/* Address */}
//         <div>
//           <h3 className="text-lg font-semibold text-slate-800 mb-2">Address Details</h3>

//           <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//             {renderInput("Address Line 1", "address1")}
//             {renderInput("Address Line 2", "address2")}
//             {renderInput("Pincode", "pincode")}
//             {renderInput("State", "state", "text", true)}
//             {renderInput("District", "district", "text", true)}
//             {renderInput("Taluka", "taluka", "text", true)}
//             {renderInput("Location", "location")}
//           </div>
//         </div>

//         {/* Business */}
//         <div>
//           <h3 className="text-lg font-semibold text-slate-800 mb-2">
//             Business Information
//           </h3>

//           <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//             {renderInput("Business Name", "business_name")}
//             {renderInput("Owner First Name", "owner_first")}
//             {renderInput("Owner Middle Name", "owner_middle")}
//             {renderInput("Owner Last Name", "owner_last")}
//             {renderInput("Owner Contact Number", "owner_contact")}
//             {renderInput("Owner Email ID", "owner_email", "email")}
//             {renderInput("PAN Number", "pan_no")}
//           </div>
//         </div>

//         {/* Buttons */}
//         <div className="flex justify-end gap-3">
//           <BlueButton type="button" onClick={onClose}>
//             Cancel
//           </BlueButton>
//           <BlueButton type="submit">Save Changes</BlueButton>
//         </div>
//       </form>
//     </div>
//   );
// }




// import React, { useState } from "react";
// import axios from "axios";
// import Swal from "sweetalert2";

// import { useNavigate } from "react-router-dom";
// import BlueButton from "../../../../Component/Common/BlueButton";

// export default function AddRetailerForm() {
//   const navigate = useNavigate();
//   const [loadingPin, setLoadingPin] = useState(false);

//   const [form, setForm] = useState({
//     first_name: "",
//     middle_name: "",
//     last_name: "",
//     phone_no: "",
//     official_email: "",
//     position: "",
//     address1: "",
//     address2: "",
//     pincode: "",
//     state: "",
//     district: "",
//     taluka: "",
//     location: "",
//     business_name: "",
//     owner_first: "",
//     owner_middle: "",
//     owner_last: "",
//     owner_contact: "",
//     owner_email: "",
//     pan_no: "",
//   });

//   const [errors, setErrors] = useState({});

//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     setForm((prev) => ({ ...prev, [name]: value }));

//     // Auto-fetch pincode details
//     if (name === "pincode" && value.length === 6) {
//       fetchPinDetails(value);
//     }

//     // Validate on change
//     validateField(name, value);
//   };

//   const fetchPinDetails = async (pincode) => {
//     try {
//       setLoadingPin(true);
//       const res = await axios.get(
//         `https://goelectronix.in/public/api/v1/pincode/${pincode}`
//       );

//       if (res.data?.success) {
//         setForm((prev) => ({
//           ...prev,
//           state: res.data.state,
//           district: res.data.district,
//           taluka: res.data.taluk || "",
//         }));
//         setErrors((prev) => ({ ...prev, pincode: "" }));
//       } else {
//         setErrors((prev) => ({ ...prev, pincode: "Invalid pincode" }));
//         Swal.fire("Invalid Pincode", "Enter a correct pincode.", "error");
//       }
//     } catch {
//       Swal.fire("Error", "Unable to fetch pincode details.", "error");
//     } finally {
//       setLoadingPin(false);
//     }
//   };

//   // Validation rules
//   const validateField = (name, value) => {
//     let error = "";

//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     const phoneRegex = /^[6-9]\d{9}$/;
//     const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;

//     switch (name) {
//       case "first_name":
//       case "last_name":
//       case "position":
//       case "address1":
//       case "business_name":
//       case "owner_first":
//       case "owner_last":
//         if (!value.trim()) error = "This field is required";
//         break;

//       case "phone_no":
//       case "owner_contact":
//         if (!value.trim()) error = "This field is required";
//         else if (!phoneRegex.test(value)) error = "Invalid 10-digit number";
//         break;

//       case "official_email":
//       case "owner_email":
//         if (!value.trim()) error = "This field is required";
//         else if (!emailRegex.test(value)) error = "Invalid email address";
//         break;

//       case "pincode":
//         if (!value.trim()) error = "This field is required";
//         else if (value.length !== 6) error = "Pincode must be 6 digits";
//         break;

//       case "pan_no":
//         if (!value.trim()) error = "This field is required";
//         else if (!panRegex.test(value)) error = "Invalid PAN format (e.g., ABCDE1234F)";
//         break;

//       default:
//         break;
//     }

//     setErrors((prev) => ({ ...prev, [name]: error }));
//     return error === "";
//   };

//   const validateForm = () => {
//     let valid = true;
//     Object.keys(form).forEach((key) => {
//       const isFieldValid = validateField(key, form[key]);
//       if (!isFieldValid) valid = false;
//     });
//     return valid;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!validateForm()) {
//       Swal.fire("Error", "Please fix validation errors", "error");
//       return;
//     }

//     try {
//       await axios.post("https://your-api.com/retailers", form);
//       Swal.fire("Success", "Retailer added successfully!", "success").then(() =>
//         navigate("/retailers")
//       );
//     } catch (err) {
//       Swal.fire("Error", "Failed to save retailer.", "error");
//     }
//   };

//   // Render input with error helper
//   const renderInput = (label, name, type = "text", readOnly = false) => (
//     <div>
//       <label className="block text-sm font-medium text-slate-700">{label}</label>
//       <input
//         type={type}
//         name={name}
//         value={form[name]}
//         required
//         onChange={handleChange}
//         readOnly={readOnly}
//         maxLength={name === "pincode" ? 6 : undefined}
//         className={`mt-1 border rounded-lg px-3 py-2 text-sm w-full ${
//           readOnly ? "bg-gray-100" : ""
//         }`}
//       />
//       {errors[name] && <p className="text-xs text-red-500 mt-1">{errors[name]}</p>}
//       {loadingPin && name === "pincode" && (
//         <p className="text-xs text-blue-600 mt-1">Fetching...</p>
//       )}
//     </div>
//   );

//   return (
//     <div className="mx-auto bg-white shadow-md rounded-2xl p-4 mt-2 mb-10">
//       {/* <h2 className="text-2xl font-semibold text-primary mb-4">Add New Retailer</h2> */}

//       <form onSubmit={handleSubmit} className="space-y-8">
//         {/* Personal Info */}
//         <div>
//           <h3 className="text-lg font-semibold text-slate-800 mb-2">
//             Authorised Person Information
//           </h3>
//           <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//             {renderInput("First Name", "first_name")}
//             {renderInput("Middle Name", "middle_name")}
//             {renderInput("Last Name", "last_name")}
//             {renderInput("Phone Number", "phone_no")}
//             {renderInput("Official Email ID", "official_email", "email")}
//             {renderInput("Position", "position")}
//           </div>
//         </div>

//         {/* Address */}
//         <div>
//           <h3 className="text-lg font-semibold text-slate-800 mb-2">Address Details</h3>
//           <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//             {renderInput("Address Line 1", "address1")}
//             {renderInput("Address Line 2", "address2")}
//             {renderInput("Pincode", "pincode")}
//             {renderInput("State", "state", "text", true)}
//             {renderInput("District", "district", "text", true)}
//             {renderInput("Taluka", "taluka", "text", true)}
//             {renderInput("Location", "location")}
//           </div>
//         </div>

//         {/* Business Info */}
//         <div>
//           <h3 className="text-lg font-semibold text-slate-800 mb-2">Business Information</h3>
//           <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//             {renderInput("Business Name", "business_name")}
//             {renderInput("Owner First Name", "owner_first")}
//             {renderInput("Owner Middle Name", "owner_middle")}
//             {renderInput("Owner Last Name", "owner_last")}
//             {renderInput("Owner Contact Number", "owner_contact")}
//             {renderInput("Owner Email ID", "owner_email", "email")}
//             {renderInput("PAN Number", "pan_no")}
//           </div>
//         </div>

//         {/* Buttons */}
//         <div className="flex justify-end gap-3">
//           <BlueButton type="button" onClick={() => navigate("/retailers")}>
//             Cancel
//           </BlueButton>
//           <BlueButton type="submit">Save Retailer</BlueButton>
//         </div>
//       </form>
//     </div>
//   );
// }


// import React, { useState } from "react";
// import axios from "axios";
// import Swal from "sweetalert2";
// import BlueButton from "../../../Component/BlueButton";
// import { useNavigate } from "react-router-dom";

// export default function AddRetailerForm() {
//   const navigate = useNavigate();

//   const [loadingPin, setLoadingPin] = useState(false);

//   const [form, setForm] = useState({
//     // Personal (Authorised Person)
//     first_name: "",
//     middle_name: "",
//     last_name: "",
//     phone_no: "",
//     official_email: "",
//     position: "",

//     // Address
//     address1: "",
//     address2: "",
//     pincode: "",
//     state: "",
//     district: "",
//     taluka: "",
//     location: "",

//     // Business Details
//     business_name: "",
//     owner_first: "",
//     owner_middle: "",
//     owner_last: "",
//     owner_contact: "",
//     owner_email: "",

//     // Unique Identity
//     pan_no: "",
//   });

//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     setForm((prev) => ({
//       ...prev,
//       [name]: value,
//     }));

//     if (name === "pincode" && value.length === 6) {
//       fetchPinDetails(value);
//     }
//   };

//   const fetchPinDetails = async (pincode) => {
//     try {
//       setLoadingPin(true);
//       const res = await axios.get(
//         `https://goelectronix.in/public/api/v1/pincode/${pincode}`
//       );

//       if (res.data?.success) {
//         setForm((prev) => ({
//           ...prev,
//           state: res.data.state,
//           district: res.data.district,
//           taluka: res.data.taluk || "",
//         }));
//       } else {
//         Swal.fire("Invalid Pincode", "Enter a correct pincode.", "error");
//       }
//     } catch {
//       Swal.fire("Error", "Unable to fetch pincode details.", "error");
//     } finally {
//       setLoadingPin(false);
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     try {
//       await axios.post("https://your-api.com/retailers", form);

//       Swal.fire("Success", "Retailer added successfully!", "success").then(() =>
//         navigate("/retailers")
//       );
//     } catch (err) {
//       Swal.fire("Error", "Failed to save retailer.", "error");
//     }
//   };

//   return (
//     <div className="mx-auto bg-white shadow-md rounded-2xl p-2 mt-2 mb-10">
//       <h2 className="text-2xl font-semibold text-primary mb-4">
//         Add New Retailer
//       </h2>

//       <form onSubmit={handleSubmit} className="space-y-8">
//         {/* PERSONAL INFORMATION */}
//         <div>
//           <h3 className="text-lg font-semibold text-slate-800 mb-2">
//             Authorised Person Information
//           </h3>

//           <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//             {/* First Name */}
//             <div>
//               <label className="block text-sm font-medium text-slate-700">
//                 First Name
//               </label>
//               <input
//                 name="first_name"
//                 value={form.first_name}
//                 onChange={handleChange}
//                 className="mt-1 border rounded-lg px-3 py-2 text-sm w-full"
//               />
//             </div>

//             {/* Middle Name */}
//             <div>
//               <label className="block text-sm font-medium text-slate-700">
//                 Middle Name
//               </label>
//               <input
//                 name="middle_name"
//                 value={form.middle_name}
//                 onChange={handleChange}
//                 className="mt-1 border rounded-lg px-3 py-2 text-sm w-full"
//               />
//             </div>

//             {/* Last Name */}
//             <div>
//               <label className="block text-sm font-medium text-slate-700">
//                 Last Name
//               </label>
//               <input
//                 name="last_name"
//                 value={form.last_name}
//                 onChange={handleChange}
//                 className="mt-1 border rounded-lg px-3 py-2 text-sm w-full"
//               />
//             </div>

//             {/* Phone */}
//             <div>
//               <label className="block text-sm font-medium text-slate-700">
//                 Phone Number
//               </label>
//               <input
//                 name="phone_no"
//                 value={form.phone_no}
//                 onChange={handleChange}
//                 className="mt-1 border rounded-lg px-3 py-2 text-sm w-full"
//               />
//             </div>

//             {/* Email */}
//             <div>
//               <label className="block text-sm font-medium text-slate-700">
//                 Official Email ID
//               </label>
//               <input
//                 name="official_email"
//                 value={form.official_email}
//                 onChange={handleChange}
//                 className="mt-1 border rounded-lg px-3 py-2 text-sm w-full"
//               />
//             </div>

//             {/* Position */}
//             <div>
//               <label className="block text-sm font-medium text-slate-700">
//                 Position
//               </label>
//               <input
//                 name="position"
//                 value={form.position}
//                 onChange={handleChange}
//                 className="mt-1 border rounded-lg px-3 py-2 text-sm w-full"
//               />
//             </div>
//           </div>
//         </div>

//         {/* ADDRESS SECTION */}
//         <div>
//           <h3 className="text-lg font-semibold text-slate-800 mb-2">
//             Address Details
//           </h3>

//           <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//             {/* Address 1 */}
//             <div>
//               <label className="block text-sm font-medium text-slate-700">
//                 Address Line 1
//               </label>
//               <input
//                 name="address1"
//                 value={form.address1}
//                 onChange={handleChange}
//                 className="mt-1 border rounded-lg px-3 py-2 text-sm w-full"
//               />
//             </div>

//             {/* Address 2 */}
//             <div>
//               <label className="block text-sm font-medium text-slate-700">
//                 Address Line 2
//               </label>
//               <input
//                 name="address2"
//                 value={form.address2}
//                 onChange={handleChange}
//                 className="mt-1 border rounded-lg px-3 py-2 text-sm w-full"
//               />
//             </div>

//             {/* Pincode */}
//             <div>
//               <label className="block text-sm font-medium text-slate-700">
//                 Pincode
//               </label>
//               <input
//                 name="pincode"
//                 value={form.pincode}
//                 maxLength={6}
//                 onChange={handleChange}
//                 className="mt-1 border rounded-lg px-3 py-2 text-sm w-full"
//               />
//               {loadingPin && (
//                 <p className="text-xs text-blue-600 mt-1">Fetching...</p>
//               )}
//             </div>

//             {/* State */}
//             <div>
//               <label className="block text-sm font-medium text-slate-700">
//                 State
//               </label>
//               <input
//                 name="state"
//                 readOnly
//                 value={form.state}
//                 className="mt-1 border rounded-lg px-3 py-2 text-sm w-full bg-gray-100"
//               />
//             </div>

//             {/* District */}
//             <div>
//               <label className="block text-sm font-medium text-slate-700">
//                 District
//               </label>
//               <input
//                 name="district"
//                 readOnly
//                 value={form.district}
//                 className="mt-1 border rounded-lg px-3 py-2 text-sm w-full bg-gray-100"
//               />
//             </div>

//             {/* Taluka */}
//             <div>
//               <label className="block text-sm font-medium text-slate-700">
//                 Taluka
//               </label>
//               <input
//                 name="taluka"
//                 readOnly
//                 value={form.taluka}
//                 className="mt-1 border rounded-lg px-3 py-2 text-sm w-full bg-gray-100"
//               />
//             </div>

//             {/* Location */}
//             <div>
//               <label className="block text-sm font-medium text-slate-700">
//                 Location
//               </label>
//               <input
//                 name="location"
//                 value={form.location}
//                 onChange={handleChange}
//                 className="mt-1 border rounded-lg px-3 py-2 text-sm w-full"
//               />
//             </div>
//           </div>
//         </div>

//         {/* BUSINESS DETAILS */}
//         <div>
//           <h3 className="text-lg font-semibold text-slate-800 mb-2">
//             Business Information
//           </h3>

//           <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//             {/* Business Name */}
//             <div>
//               <label className="block text-sm font-medium text-slate-700">
//                 Business Name
//               </label>
//               <input
//                 name="business_name"
//                 value={form.business_name}
//                 onChange={handleChange}
//                 className="mt-1 border rounded-lg px-3 py-2 text-sm w-full"
//               />
//             </div>

//             {/* Owner First Name */}
//             <div>
//               <label className="block text-sm font-medium text-slate-700">
//                 Owner First Name
//               </label>
//               <input
//                 name="owner_first"
//                 value={form.owner_first}
//                 onChange={handleChange}
//                 className="mt-1 border rounded-lg px-3 py-2 text-sm w-full"
//               />
//             </div>

//             {/* Owner Middle Name */}
//             <div>
//               <label className="block text-sm font-medium text-slate-700">
//                 Owner Middle Name
//               </label>
//               <input
//                 name="owner_middle"
//                 value={form.owner_middle}
//                 onChange={handleChange}
//                 className="mt-1 border rounded-lg px-3 py-2 text-sm w-full"
//               />
//             </div>

//             {/* Owner Last Name */}
//             <div>
//               <label className="block text-sm font-medium text-slate-700">
//                 Owner Last Name
//               </label>
//               <input
//                 name="owner_last"
//                 value={form.owner_last}
//                 onChange={handleChange}
//                 className="mt-1 border rounded-lg px-3 py-2 text-sm w-full"
//               />
//             </div>

//             {/* Owner Contact */}
//             <div>
//               <label className="block text-sm font-medium text-slate-700">
//                 Owner Contact Number
//               </label>
//               <input
//                 name="owner_contact"
//                 value={form.owner_contact}
//                 onChange={handleChange}
//                 className="mt-1 border rounded-lg px-3 py-2 text-sm w-full"
//               />
//             </div>

//             {/* Owner Email */}
//             <div>
//               <label className="block text-sm font-medium text-slate-700">
//                 Owner Email ID
//               </label>
//               <input
//                 name="owner_email"
//                 value={form.owner_email}
//                 onChange={handleChange}
//                 className="mt-1 border rounded-lg px-3 py-2 text-sm w-full"
//               />
//             </div>

//             {/* PAN */}
//             <div>
//               <label className="block text-sm font-medium text-slate-700">
//                 PAN Number
//               </label>
//               <input
//                 name="pan_no"
//                 value={form.pan_no}
//                 onChange={handleChange}
//                 className="mt-1 border rounded-lg px-3 py-2 text-sm w-full"
//               />
//             </div>
//           </div>
//         </div>

//         {/* ACTION BUTTONS */}
//         <div className="flex justify-end gap-3">
//           <BlueButton type="button" onClick={() => navigate("/retailers")}>
//             Cancel
//           </BlueButton>
//           <BlueButton type="submit">Save Retailer</BlueButton>
//         </div>
//       </form>
//     </div>
//   );
// }
